import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { reactive, toRefs, watch } from "vue";
import apis from "@/api";
import download from "@/utils/download";
import { srcType } from "@/utils/srcType";
export default {
  props: {
    id: String
  },
  setup(props, ctx) {
    const {
      batchDownload
    } = download();
    let data = reactive({
      positionId: "",
      queryParam: {},
      tabNum: "1",
      pageSize: 10,
      pageNo: 1,
      loading: true,
      tableData: [],
      userAreaName: '',
      checkedAssetSet: new Set(),
      tableTotal: 0,
      srcType: srcType,
      check: false,
      isDownloading: false,
      isBatchDownloading: false,
      downId: ''
    });
    const loadData = () => {
      data.loading = true;
      data.tableData = [];
      let params = Object.assign({}, data.queryParam, {
        positionId: data.positionId,
        tab: data.tabNum,
        pageNo: data.pageNo,
        pageSize: data.pageSize
      });
      apis.queryOffLPosBizListByArea(params).then(res => {
        if (res.success) {
          data.tableData = res.data.pageList.records;
          data.tableTotal = res.data.pageList.total;
          data.userAreaName = res.data.userAreaName;
          if (data.tableData.length > 0) {
            if (data.check) {
              // 全选
              data.tableData.forEach(item => {
                if (item.srcTyp === '4' || item.srcTyp === '7') {
                  // 文本不被选择下载
                  return;
                }
                data.checkedAssetSet.add(item.assetsId);
                item.checked = true;
              });
            } else {
              // 不全选
              data.tableData.forEach(item => {
                item.checked = false;
              });
            }
            console.log(data.checkedAssetSet, "data.checkedAssetSet");
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    const handleClick = (tab, event) => {
      data.tabNum = tab.props.name;
      loadData();
    };
    const handleSizeChange = val => {
      console.log(`每页 ${val} 条`);
      data.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      console.log(`当前页: ${val}`);
      data.pageNo = val;
      loadData();
    };

    // 开启选择模式
    const checkModel = () => {
      data.check = true;
    };

    // 全选，取消
    const checkedAll = p => {
      data.check = p;
      if (p) {
        data.tableData.forEach(item => {
          if (item.srcTyp === '4' || item.srcTyp === '7') {
            // 文本不被选择下载
            return;
          }
          data.checkedAssetSet.add(item.assetsId);
          item.checked = true;
        });
      } else {
        data.checkedAssetSet.clear();
        data.tableData.forEach(item => {
          item.checked = false;
        });
      }
      console.log(data.checkedAssetSet, "data.checkedAssetSet");
    };

    // 单选，取消
    const checked = id => {
      if (data.check) {
        // 选择模式
        console.log(id, "checked id");
        data.tableData.forEach(item => {
          if (item.id == id) {
            if (item.srcTyp === '4' || item.srcTyp === '7') {
              // 文本不被选择下载
              ElMessage.warning("文本内容素材不能下载");
              return;
            }
            if (item.checked) {
              data.checkedAssetSet.delete(item.assetsId);
              item.checked = false;
            } else {
              data.checkedAssetSet.add(item.assetsId);
              item.checked = true;
            }
          }
        });
        console.log(data.checkedAssetSet, "data.checkedAssetSet");
      }
    };
    const downloadAssets = p => {
      if (p === 'checked') {
        if (data.checkedAssetSet.size == 0) {
          ElMessage.warning("请选择要下载的素材");
          return;
        }
        data.isBatchDownloading = true;
        let asset = [];
        Array.from(data.checkedAssetSet).forEach(id => {
          data.tableData.forEach(value => {
            if (value.assetsId == id) {
              asset.push({
                id: id,
                name: value.assetsName
              });
            }
          });
        });
        batchDownload(asset).finally(() => {
          data.isBatchDownloading = false;
        });
        sendDownLog(Array.from(data.checkedAssetSet));
      } else {
        data.isDownloading = true;
        data.downId = p;
        let assetName = "";
        data.tableData.forEach(value => {
          if (value.assetsId == p) {
            assetName = value.assetsName;
          }
        });
        batchDownload(Array.from([{
          id: p,
          name: assetName
        }])).finally(() => {
          data.isDownloading = false;
        });
        sendDownLog([p]);
      }
    };
    const sendDownLog = ids => {
      apis.downLog(ids.join(",")).then(res => {
        if (res.success) {
          console.log("下载记录成功");
        }
      });
    };
    watch(() => props.id, id => {
      data.positionId = id;
      loadData();
    }, {
      immediate: true
    });
    return {
      ...toRefs(data),
      handleClick,
      handleSizeChange,
      handleCurrentChange,
      loadData,
      checkModel,
      checkedAll,
      checked,
      downloadAssets,
      sendDownLog,
      batchDownload
    };
  },
  name: "PositionBizPutResList"
};